import { render, staticRenderFns } from "./ModalBottom.vue?vue&type=template&id=1e23d9a9&scoped=true&"
import script from "./ModalBottom.vue?vue&type=script&lang=js&"
export * from "./ModalBottom.vue?vue&type=script&lang=js&"
import style0 from "./ModalBottom.vue?vue&type=style&index=0&id=1e23d9a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23d9a9",
  null
  
)

export default component.exports